// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fake-input[data-v-604e2ed8]{display:flex;flex-direction:column;min-height:55px}.fake-input .label[data-v-604e2ed8]{color:#646464;font-size:10px;line-height:12px;margin-bottom:0}.fake-input .value[data-v-604e2ed8]{color:#424242;font-size:16px;min-height:40px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
